import { BCMSRecord, Branding, useGlobalController, useParams } from "@bcm-dev/bcms-vite";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import LeftColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/LeftColumnContainer";
import RightColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/RightColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import ActivityViewOnlyRecurring from "compid/shared/views/BillerView/components/views/ActivityViewOnlyRecurring";
import AllActivityView from "compid/shared/views/BillerView/components/views/AllActivityView";
import EditableActivityView from "compid/shared/views/BillerView/components/views/EditableActivityView";
import PaidActivityView from "compid/shared/views/BillerView/components/views/PaidActivityView";
import NavView from "compid/shared/views/NavView";
import VerticalMenuView from "compid/shared/views/VerticalMenuView";
import { Account, Bill, Biller, Payment, ShowOnDesktop, ShowOnMobile } from "model";
import React, { useEffect, useState } from "react";
import ActivityFilter from "./classes/ActivityFilter";
import ActiveAutopaysWidget from "./components/ActiveAutopaysWidget";
import ActivitySearchField from "./components/ActivitySearchField";
import CanceledPaymentPrompt from "./components/CanceledPaymentPrompt";
import FilterBarWidget from "./components/FilterBarWidget";
import "./styles.css";

const ActivityPageContext = React.createContext(null);

export default function ActivityPage(props) {

  return(
    <PageView className="activity-page">
     <ShowOnDesktop>
       <div className="show-on-desktop">
        <Branding id="menu_position_rxp22" value="Vertical">
          <div className="flex-container flex-horizontal vertical-menu-page-container">
           
            {/* <NavView /> */}
            <ActivityPageContent>
            <VerticalMenuView />
        </ActivityPageContent>
            </div>
        </Branding>
        <Branding id="menu_position_rxp22" exp={ value => value === "Horizontal" || value === "undefined" }>
           
            <ActivityPageContent>
            <NavView />
        </ActivityPageContent>
        </Branding>
      </div>
     </ShowOnDesktop>
    <ShowOnMobile>
        <div className="show-on-mobile show-on-tablet">
        <ActivityPageContent>
           <NavView />
        </ActivityPageContent>
      </div>
    </ShowOnMobile>   
    
    </PageView>
  );
}
 function ActivityPageContent(props){
  const globalController = useGlobalController();
  const { billerID } = useParams();
  BCMSRecord.globalControllerFor([ Payment, Biller, Bill, Account ], globalController);

  const [ state, setState ] = useState(ActivityFilter.defaults());
  const { filters } = state ?? {};
  const { didFilter } = filters ?? {};
  const [prefillSearch, setPrefillSearch] = useState(false);

  const selectedBillerID = billerID ?? "";
  const selectedBiller = Biller.initAll().filter( biller => biller.id === selectedBillerID);

  const controller = ActivityFilter.init(state, setState);

  // Search field is prefilled when navigating from
  // Biller Details when clicking the "View all activity" link.
  if(!prefillSearch && selectedBiller.length > 0) {
    setPrefillSearch(true);
    controller.setFilter("search", selectedBiller[0]);
  }
  useEffect(() => setState(ActivityFilter.defaults()), [ globalController.state ]);
    return  <>
    {props.children}
    <PageLayoutContainer>
        <LeftColumnContainer>
          <ActivityPageContext.Provider value={ controller }>
            {/*<StickyHeaderView>*/}
              <CanceledPaymentPrompt />
            {/*</StickyHeaderView>*/}
            
            {/*<StickyHeaderView zIndex={ 501 }>*/}
              <ActivitySearchField placeholder="Search" selectedBillerID={ billerID } />
            {/*</StickyHeaderView>*/}
            <FilterBarWidget />

            { didFilter
            ? <AllActivityView/>
            : <>
              <EditableActivityView />
              <ActivityViewOnlyRecurring />
              <PaidActivityView />
            </>
            }
          </ActivityPageContext.Provider>
        </LeftColumnContainer>
        
        <RightColumnContainer className="show-on-desktop">
          <ActivityPageContext.Provider value={ controller }>
            <ActiveAutopaysWidget />
          </ActivityPageContext.Provider>
        </RightColumnContainer>

    </PageLayoutContainer>
    </>
 }

export const useActivityPageContext = () => React.useContext(ActivityPageContext);